<template>
    <div class="page wrong-answers-page py-lg-6">
        <v-container :class="{'py-3': phoneOnly}">
            <v-row class="justify-center">
                <v-col cols="12" lg="9" xl="7">
                    <v-card v-if="appData.enable_student_practice" outlined class="pa-5 mb-6 rounded-xl">
                        <div class="d-flex align-center flex-wrap justify-space-between">
                            <div><h2 class="text-h6 mb-1">حوّل أخطاءك إلى فرصة للتعلّم</h2><p class="mb-3 text--secondary">أسئلة جديدة على المفاهيم التي تحتاج إلى مراجعتها.</p></div>
                            <v-btn color="indigo" dark large :to="{name:'practice-exams'}"><v-icon left>mdi-auto-fix</v-icon>اختبرني من أخطائي</v-btn>
                        </div>
                    </v-card>
                    <transition name="fade-transition" mode="out-in">
                        <template v-if="!loading || loadedOnce">
                            <infinity-wrapper v-if="attempts && attempts.length" @load="load(false)" key="attempts">
                                <wrong-answer-card v-for="attempt in attempts" :key="attempt.id" :attempt="attempt" />
                            </infinity-wrapper>
                            <div v-else key="empty">
                                <v-alert color="blue-grey" text type="info" class="mb-0">
                                    <div class="details-text">لا توجد أسئلة خاطئة حتى الآن، أحسنت!</div>
                                </v-alert>
                            </div>
                        </template>
                        <template v-else>
                            <div key="loading">
                                <v-skeleton-loader v-for="i in 3" :key="'loading-' + i" class="bordered mb-4" type="list-item-three-line, list-item-two-line" ></v-skeleton-loader>
                            </div>
                        </template>
                    </transition>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
import WrongAnswerCard from '@/components/custom/wrong-answer-card'

export default {
    name: "WrongAnswers",
    components: {
        InfinityWrapper,
        WrongAnswerCard
    },
    data(){
        return {
            attempts: [],
            nextUrl: null,

            loading: true,
            loadedOnce: false,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        load(initialLoad = false){
            if (!initialLoad && (this.loading || !this.nextUrl)){
                return;
            }
            this.loading = true;
            const url = initialLoad ? '/exams/wrong-answers' : this.nextUrl;
            this.$store.dispatch('fastGetAction', {url}).then(response=>{
                const data = response.data;
                const items = (data.data || []).filter(attempt=>attempt.question);
                this.attempts = initialLoad ? items : this.attempts.concat(items);
                this.nextUrl = data.links ? data.links.next : null;
                this.loading = false;
                this.loadedOnce = true;

            }).catch(()=>{
                this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                this.loading = false;
            });
        },
    },
    mounted(){
        if (!this.appData.enable_wrong_answers_page){
            this.$router.push('/not-found');
            return;
        }
        this.load(true);
        this.scrollToTop();
    }
};
</script>
